var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"fluid":""}},_vm._l((_vm.about_info),function(info){return _c('v-row',{key:info.title},[_c('v-col',[_c('v-lazy',{attrs:{"options":{
            threshold: 0.5,
          },"transition":"fade-transition"}},[_c('about-card',{attrs:{"image":info.image,"image_lazy":info.image,"paragraphs":info.paragraphs,"title":info.title,"mobile":_vm.mobile}})],1)],1)],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }